import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none',
  },
  logo: {
    marginTop: 5,
    width: 120,
  },
}));

export const PublicAppBar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <RouterLink to="/">
          <img className={classes.logo} alt="Generac Logo" src="/images/logo_generac_white.svg" />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
};

PublicAppBar.propTypes = {
  className: PropTypes.string,
};
